import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c354eac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder text-light m-0" }
const _hoisted_5 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_6 = { class: "collapse show" }
const _hoisted_7 = { class: "card-body border-top p-9" }
const _hoisted_8 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Tranche", -1))
const _hoisted_14 = ["label", "value"]
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Partner", -1))
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "col-md-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Contract", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Contract", -1))
const _hoisted_22 = ["label", "value"]
const _hoisted_23 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Institute", -1))
const _hoisted_26 = ["label", "value"]
const _hoisted_27 = { class: "col-md-2 mt-2" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1))
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "mt-6" }
const _hoisted_31 = ["id"]
const _hoisted_32 = { class: "collapse show" }
const _hoisted_33 = { class: "card-body border-top p-0" }
const _hoisted_34 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_35 = { class: "table-responsive" }
const _hoisted_36 = { class: "table table-borderless gy-4 m-0" }
const _hoisted_37 = { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }
const _hoisted_38 = { rowspan: "2" }
const _hoisted_39 = ["data-bs-target"]
const _hoisted_40 = {
  rowspan: "2",
  style: {"width":"100px"}
}
const _hoisted_41 = ["data-kt-indicator", "onClick"]
const _hoisted_42 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_43 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_44 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Tranche", -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Contract", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Bill", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Claim", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Batches", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Trainee Assessed", -1))
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Trainee Employed", -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " Percentage(%) of Job Placement (Till Previous Bill) ", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, " Cumulative (%) of Job Placement (Till Current Bill) ", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Gross Amount", -1))
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Net Amount", -1))
const _hoisted_57 = {
  class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black",
  style: {"border-top":"1px solid\r\n                                      rgba(29, 182, 140, 0.51) !important"}
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))
const _hoisted_60 = ["id"]
const _hoisted_61 = ["id"]
const _hoisted_62 = { class: "collapse show" }
const _hoisted_63 = { class: "card-body border-top p-6" }
const _hoisted_64 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_65 = { class: "table-responsive mt-5" }
const _hoisted_66 = { class: "table table-borderless gy-4" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "bg-light fw-bolder fs-7 text-uppercase align-middle text-black" }, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"25%"} }, " Training Institutes "),
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"18%"} }, "Course"),
    /*#__PURE__*/_createElementVNode("th", null, "BN"),
    /*#__PURE__*/_createElementVNode("th", null, "Enroll# (A)"),
    /*#__PURE__*/_createElementVNode("th", null, "Enroll Fee %"),
    /*#__PURE__*/_createElementVNode("th", null, "Course Fee (B)"),
    /*#__PURE__*/_createElementVNode("th", null, "Total Bill (C=A*B)"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim 1 (D)"),
    /*#__PURE__*/_createElementVNode("th", null, "Cer# (E)"),
    /*#__PURE__*/_createElementVNode("th", null, "Net Bill (F=B*E)"),
    /*#__PURE__*/_createElementVNode("th", null, "Cer Fee % (CF)"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim 2 (G= F % (CF))"),
    /*#__PURE__*/_createElementVNode("th", null, "Job# (H)"),
    /*#__PURE__*/_createElementVNode("th", null, "Claim 3 (I=F-(D+G))"),
    /*#__PURE__*/_createElementVNode("th", null, "Adjustment"),
    /*#__PURE__*/_createElementVNode("th", null, "Bill Date"),
    /*#__PURE__*/_createElementVNode("th", null, "Bill No"),
    /*#__PURE__*/_createElementVNode("th", null, "Start Date"),
    /*#__PURE__*/_createElementVNode("th", null, "End Date")
  ])
], -1))
const _hoisted_68 = { style: {} }
const _hoisted_69 = { class: "align-middle" }
const _hoisted_70 = { class: "align-middle" }
const _hoisted_71 = { class: "align-middle" }
const _hoisted_72 = { class: "align-middle" }
const _hoisted_73 = { class: "align-middle" }
const _hoisted_74 = { class: "align-middle" }
const _hoisted_75 = { class: "align-middle" }
const _hoisted_76 = { class: "align-middle" }
const _hoisted_77 = { class: "align-middle" }
const _hoisted_78 = { class: "align-middle" }
const _hoisted_79 = { class: "align-middle" }
const _hoisted_80 = { class: "align-middle" }
const _hoisted_81 = { class: "align-middle" }
const _hoisted_82 = { class: "align-middle" }
const _hoisted_83 = { class: "align-middle" }
const _hoisted_84 = { class: "align-middle" }
const _hoisted_85 = { class: "align-middle" }
const _hoisted_86 = { class: "align-middle" }
const _hoisted_87 = { class: "align-middle" }
const _hoisted_88 = { class: "align-middle" }
const _hoisted_89 = { class: "align-middle" }
const _hoisted_90 = { style: {"border-bottom":"1px solid\r\n                                                rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "3",
  class: "font-weight-bold text-black"
}, " Total ", -1))
const _hoisted_92 = { class: "font-weight-bold text-black" }
const _hoisted_93 = { class: "font-weight-bold text-black" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "4" }, null, -1))
const _hoisted_95 = { class: "font-weight-bold text-black" }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { colspan: "3" }, null, -1))
const _hoisted_97 = { class: "font-weight-bold text-black" }
const _hoisted_98 = { class: "font-weight-bold text-black" }
const _hoisted_99 = { class: "font-weight-bold text-black" }
const _hoisted_100 = { style: {"border-bottom":"1px solid\r\n                                                rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " A) Gross Amount ", -1))
const _hoisted_102 = { class: "font-weight-bold text-black" }
const _hoisted_103 = { style: {"border-bottom":"1px solid\r\n                                                rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " B) IA'S Contribution ", -1))
const _hoisted_105 = { class: "font-weight-bold text-black" }
const _hoisted_106 = { style: {"border-bottom":"1px solid\r\n                                                rgba(29, 182, 140, 0.51) !important"} }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " C) Contribution Amount (A*B) ", -1))
const _hoisted_108 = { class: "font-weight-bold text-black" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " D) Bill Amount (A - C) ", -1))
const _hoisted_110 = { class: "font-weight-bold text-black" }
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " E) Adjustment of Mobilization Advance (D * 40%) ", -1))
const _hoisted_112 = { class: "font-weight-bold text-black" }
const _hoisted_113 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  colspan: "14",
  class: "font-weight-bold text-black text-end"
}, " F) Net Payable (D - E) ", -1))
const _hoisted_114 = { class: "font-weight-bold text-black" }
const _hoisted_115 = { class: "text-end" }
const _hoisted_116 = ["data-kt-indicator", "onClick"]
const _hoisted_117 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_118 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_119 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, " Claim-3: Approved Bills for " + _toDisplayString(_ctx.entity_short_name), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _hoisted_12,
                _withDirectives(_createElementVNode("select", {
                  class: "form-control py-2",
                  placeholder: "Select Tranche",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.bill.tranche_id) = $event)),
                  style: {"width":"100%"}
                }, [
                  _hoisted_13,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches, (trans) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: trans.id,
                      label: trans.label,
                      value: trans.id
                    }, _toDisplayString(trans.label), 9, _hoisted_14))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.bill.tranche_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("select", {
                  class: "form-control py-2",
                  placeholder: "Select Partner",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.bill.entity_id) = $event)),
                  style: {"width":"100%"},
                  onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.entityNameChange(_ctx.bill.entity_id)))
                }, [
                  _hoisted_17,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (data) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: data.id,
                      value: data.id
                    }, " [" + _toDisplayString(data.entity_short_name) + "]-" + _toDisplayString(data.entity_name), 9, _hoisted_18))
                  }), 128))
                ], 544), [
                  [_vModelSelect, _ctx.bill.entity_id]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("select", {
                  class: "form-control py-2",
                  placeholder: "Select Contract",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.bill.entity_contract_id) = $event)),
                  style: {"width":"100%"}
                }, [
                  _hoisted_21,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contractInfos, (data) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: data.id,
                      label: data.contract_name,
                      value: data.id
                    }, _toDisplayString(data.contract_name), 9, _hoisted_22))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.bill.entity_contract_id]
                ])
              ]),
              (_ctx.showInstitute)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control py-2",
                      placeholder: "Select Institute",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.bill.institute_info_id) = $event)),
                      style: {"width":"100%"}
                    }, [
                      _hoisted_25,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteInfos, (data) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: data.id,
                          label: data.institute_name,
                          value: data.id
                        }, _toDisplayString(data.institute_name), 9, _hoisted_26))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.bill.institute_info_id]
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("button", {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getBillList())),
                  type: "submit",
                  class: "btn btn-success p-3 mt-6",
                  style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                }, [
                  _createTextVNode(" Search "),
                  _hoisted_28
                ])
              ])
            ]),
            (_ctx.showBillList)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createElementVNode("h4", _hoisted_30, " Claim-3 Bill Detail (Total Bill Found : " + _toDisplayString(_ctx.billList.length) + ") ", 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billList, (bl, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "card mb-5 mb-xl-10 mt-4"
                    }, [
                      _createElementVNode("div", {
                        id: ['claim_' + index + '_bill_data'],
                        class: "collapse show"
                      }, [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("div", _hoisted_34, [
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("table", _hoisted_36, [
                                  _createElementVNode("thead", null, [
                                    _createElementVNode("tr", _hoisted_37, [
                                      _createElementVNode("th", _hoisted_38, [
                                        _createElementVNode("i", {
                                          class: "fas fa-angle-down text-black fs-2x",
                                          role: "button",
                                          "data-bs-toggle": "collapse",
                                          "data-bs-target": ['#billList' + index],
                                          "aria-expanded": "false",
                                          "aria-controls": "form"
                                        }, null, 8, _hoisted_39)
                                      ]),
                                      _createElementVNode("th", _hoisted_40, [
                                        _createElementVNode("button", {
                                          "data-kt-indicator": _ctx.loading ? 'on' : null,
                                          class: "btn btn-sm btn-dark ml-3 p-3",
                                          title: "Invoice",
                                          style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                                          type: "submit",
                                          onClick: ($event: any) => (_ctx.downloadPdf(bl))
                                        }, [
                                          (!_ctx.loading)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                                _createTextVNode(" Invoice "),
                                                _createElementVNode("span", _hoisted_43, [
                                                  _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                                                ])
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.loading)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                                _createTextVNode(" Please wait... "),
                                                _hoisted_45
                                              ]))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_41)
                                      ]),
                                      _hoisted_46,
                                      _hoisted_47,
                                      _hoisted_48,
                                      _hoisted_49,
                                      _hoisted_50,
                                      _hoisted_51,
                                      _hoisted_52,
                                      _hoisted_53,
                                      _hoisted_54,
                                      _hoisted_55,
                                      _hoisted_56
                                    ]),
                                    _createElementVNode("tr", _hoisted_57, [
                                      _createElementVNode("th", null, _toDisplayString(bl?.tranche_label), 1),
                                      _createElementVNode("th", null, _toDisplayString(bl?.contract), 1),
                                      _createElementVNode("th", null, _toDisplayString(bl?.bill_sequence_no), 1),
                                      _createElementVNode("th", null, _toDisplayString(bl?.claim_no), 1),
                                      _createElementVNode("th", null, _toDisplayString(bl?.total_batch), 1),
                                      _createElementVNode("th", null, _toDisplayString(bl?.total_trainee), 1),
                                      _createElementVNode("th", null, _toDisplayString(bl?.total_job_placement), 1),
                                      _hoisted_58,
                                      _hoisted_59,
                                      _createElementVNode("th", null, _toDisplayString(Number( bl?.gross_amount).toLocaleString()), 1),
                                      _createElementVNode("th", null, _toDisplayString(Number(bl?.net_amount).toLocaleString()), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", {
                                id: ['billList' + index],
                                class: "collapse card mb-5 mb-xl-10 m-5"
                              }, [
                                _createElementVNode("div", {
                                  id: ['claim_' + index + '_bill_dta'],
                                  class: "collapse show"
                                }, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("div", _hoisted_64, [
                                        _createElementVNode("div", _hoisted_65, [
                                          _createElementVNode("table", _hoisted_66, [
                                            _hoisted_67,
                                            _createElementVNode("tbody", _hoisted_68, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bl.bill_list, (data, ix) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                  key: ix,
                                                  style: {"border-bottom":"1px solid\r\n                                                  rgba(29, 182, 140, 0.51) !important"}
                                                }, [
                                                  _createElementVNode("td", _hoisted_69, _toDisplayString(index + 1), 1),
                                                  _createElementVNode("td", _hoisted_70, _toDisplayString(data?.institute_info
                                                    ?.institute_name) + " ( " + _toDisplayString(data?.institute_info
                                                    ?.short_name) + " ) ", 1),
                                                  _createElementVNode("td", _hoisted_71, _toDisplayString(data?.course_info?.course_name) + " | " + _toDisplayString(data?.course_info?.month) + " | " + _toDisplayString(data?.course_info?.hour) + " | " + _toDisplayString(data?.course_info
                                                    ?.unit_cost_total), 1),
                                                  _createElementVNode("td", _hoisted_72, _toDisplayString(data?.batch_info?.batch_sequence_number), 1),
                                                  _createElementVNode("td", _hoisted_73, _toDisplayString(data?.enroll_count), 1),
                                                  _createElementVNode("td", _hoisted_74, _toDisplayString(data?.e_pay_percentage), 1),
                                                  _createElementVNode("td", _hoisted_75, _toDisplayString(data.unit_cost.toFixed(2)), 1),
                                                  _createElementVNode("td", _hoisted_76, _toDisplayString(Number(data?.total_bill_amount).toLocaleString()), 1),
                                                  _createElementVNode("td", _hoisted_77, _toDisplayString(Number(data?.e_bill_amount).toLocaleString()), 1),
                                                  _createElementVNode("td", _hoisted_78, _toDisplayString(data?.certification_count), 1),
                                                  _createElementVNode("td", _hoisted_79, _toDisplayString(Number(data?.net_bill).toLocaleString()), 1),
                                                  _createElementVNode("td", _hoisted_80, _toDisplayString(data?.c_pay_percentage), 1),
                                                  _createElementVNode("td", _hoisted_81, _toDisplayString() + " " + _toDisplayString(Number(data?.cer_bill_amount).toLocaleString()), 1),
                                                  _createElementVNode("td", _hoisted_82, _toDisplayString(data?.placement_count), 1),
                                                  _createElementVNode("td", _hoisted_83, _toDisplayString(data?.claim_3_count), 1),
                                                  _createElementVNode("td", _hoisted_84, _toDisplayString(Number(data?.bill_amount).toLocaleString()), 1),
                                                  _createElementVNode("td", _hoisted_85, _toDisplayString(Number(data?.remaining_balance).toLocaleString()), 1),
                                                  _createElementVNode("td", _hoisted_86, _toDisplayString(data?.bill_date), 1),
                                                  _createElementVNode("td", _hoisted_87, _toDisplayString(data?.bill_no), 1),
                                                  _createElementVNode("td", _hoisted_88, _toDisplayString(data?.batch_info?.start_date), 1),
                                                  _createElementVNode("td", _hoisted_89, _toDisplayString(data?.batch_info?.end_date), 1)
                                                ]))
                                              }), 128))
                                            ]),
                                            _createElementVNode("tfoot", null, [
                                              _createElementVNode("tr", _hoisted_90, [
                                                _hoisted_91,
                                                _createElementVNode("th", _hoisted_92, _toDisplayString(bl.bill_list.length), 1),
                                                _createElementVNode("th", _hoisted_93, _toDisplayString(bl?.total_enroll), 1),
                                                _hoisted_94,
                                                _createElementVNode("th", _hoisted_95, _toDisplayString(bl?.total_certified), 1),
                                                _hoisted_96,
                                                _createElementVNode("th", _hoisted_97, _toDisplayString(bl?.total_job_placement), 1),
                                                _createElementVNode("th", _hoisted_98, _toDisplayString(bl?.total_trainee), 1),
                                                _createElementVNode("th", _hoisted_99, _toDisplayString(Number( bl?.gross_amount).toLocaleString()), 1)
                                              ]),
                                              _createElementVNode("tr", _hoisted_100, [
                                                _hoisted_101,
                                                _createElementVNode("th", _hoisted_102, _toDisplayString(Number( bl?.gross_amount).toLocaleString()), 1)
                                              ]),
                                              _createElementVNode("tr", _hoisted_103, [
                                                _hoisted_104,
                                                _createElementVNode("th", _hoisted_105, _toDisplayString(bl?.contribution_percentage.toFixed(
                                                  2
                                                )), 1)
                                              ]),
                                              _createElementVNode("tr", _hoisted_106, [
                                                _hoisted_107,
                                                _createElementVNode("th", _hoisted_108, _toDisplayString(Number(bl?.contribution_amount).toLocaleString()), 1)
                                              ]),
                                              _createElementVNode("tr", null, [
                                                _hoisted_109,
                                                _createElementVNode("th", _hoisted_110, _toDisplayString(Number(bl?.bill_after_contribution).toLocaleString()), 1)
                                              ]),
                                              _createElementVNode("tr", null, [
                                                _hoisted_111,
                                                _createElementVNode("th", _hoisted_112, _toDisplayString(Number(bl?.adjustment_amount).toLocaleString()), 1)
                                              ]),
                                              _createElementVNode("tr", null, [
                                                _hoisted_113,
                                                _createElementVNode("th", _hoisted_114, _toDisplayString(Number( bl?.gross_amount).toLocaleString()), 1)
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_115, [
                                          _createElementVNode("button", {
                                            "data-kt-indicator": 
                                          _ctx.loading ? 'on' : null
                                        ,
                                            class: "btn btn-sm btn-dark ml-3 p-3",
                                            title: "Invoice",
                                            style: {"padding-top":"8px !important","padding-bottom":"8px !important"},
                                            type: "submit",
                                            onClick: ($event: any) => (_ctx.downloadPdf(bl))
                                          }, [
                                            (!_ctx.loading)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_117, [
                                                  _createTextVNode(" Invoice "),
                                                  _createElementVNode("span", _hoisted_118, [
                                                    _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                                                  ])
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.loading)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_119, [
                                                  _createTextVNode(" Please wait... "),
                                                  _hoisted_120
                                                ]))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_116)
                                        ])
                                      ])
                                    ])
                                  ])
                                ], 8, _hoisted_61)
                              ], 8, _hoisted_60)
                            ])
                          ])
                        ])
                      ], 8, _hoisted_31)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}